module.exports = __webpack_public_path__ + "img/bulb_ig.20e98b9c.png";